import React, { FC } from 'react'

import { Colors } from 'common-constants/colors'

export const DeletingClockSvg: FC<{
  size?: number | string
}> = ({ size = 8 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1393_38945)">
      <circle cx="4" cy="4" r="4" fill={Colors.dark} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 1.23755C4.22091 1.23755 4.4 1.41663 4.4 1.63755V4.00005C4.4 4.22096 4.22091 4.40005 4 4.40005C3.77908 4.40005 3.6 4.22096 3.6 4.00005V1.63755C3.6 1.41663 3.77908 1.23755 4 1.23755Z"
        fill={Colors.backgroundHoverLight}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.76682 3.94366C3.87107 3.81488 4.05997 3.79498 4.18876 3.89923L6.18182 5.51251C6.3106 5.61675 6.3305 5.80565 6.22626 5.93444C6.12201 6.06322 5.93311 6.08311 5.80432 5.97887L3.81126 4.36559C3.68248 4.26135 3.66258 4.07244 3.76682 3.94366Z"
        fill={Colors.backgroundHoverLight}
      />
    </g>
    <defs>
      <clipPath id="clip0_1393_38945">
        <rect width={size} height={size} fill={Colors.white} />
      </clipPath>
    </defs>
  </svg>
)
